import { lazy } from 'react';

const LoadableModal = lazy(
  () =>
    import(
      /* webpackChunkName: "damz-modals" */ './CreateCommunityChannelModal'
    )
);

export default LoadableModal;
